function trueTypeOf(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

// eslint-disable-next-line import/prefer-default-export
export function objectToQueryParams(obj, parentKey = null) {
  let output = '';

  Object.keys(obj).forEach((key) => {
    let outputKey = `${key}=`;
    if (parentKey) {
      outputKey = `${parentKey}[${key}]`;
    }

    switch (trueTypeOf(obj[key])) {
      case 'object':
        output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
        break;
      case 'array':
        output += `${outputKey}=${obj[key].join(',')}&`;
        break;
      default:
        if (parentKey) {
          outputKey += '=';
        }
        output += `${outputKey + encodeURIComponent(obj[key])}&`;
        break;
    }
  });

  return output;
}
